export type SuperAdminCompanyStatus = "active" | "trial" | "past_due" | "cancelled";

export interface SuperAdminCompany {
  id: number;
  name: string;
  avatar: string | null;

  appPlan: string;
  appPlanCost: number;
  appStatus: SuperAdminCompanyStatus;
  appPlanExpiresAt: string | null;

  mobilePlan: string;
  mobilePlanCost: number;
  mobileStatus: SuperAdminCompanyStatus;
  mobilePlanExpiresAt: string | null;

  ownerName: string;
  ownerEmail: string;
  teamMembers: number;
  createdAt: string;
  lastActivity: string;
}

export interface SuperAdminCompaniesResponse {
  status: number;
  message: string;
  data: SuperAdminCompany[];
}

export const SUPER_ADMIN_COMPANIES_QUERY_KEY = ["super-admin-companies"] as const;
